var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Flex, Heading, Button, InputGroup, Stack, InputLeftElement, chakra, Box, Link, Avatar, FormControl, FormHelperText, InputRightElement, Text, } from '../../shared/components/ui';
import { useForm } from 'react-hook-form';
import { FormInput } from '../../shared/components/features/Form';
import { FaUserAlt, FaLock } from 'react-icons/fa';
import RHFDevTool from '../../shared/utils/rhfDevTool';
import axios from 'axios';
import { DIGLET_URL } from '../../config';
import { useLocalStorage, useLogout } from '../../shared/hooks/';
import { emailPattern } from 'constants/regexPatterns';
import { useNavigate } from 'react-router-dom';
var scopes = [
    'group:admin',
    'group:medical_biller',
    'group:super_admin',
    'group:compass:care_provider',
    'group:compass:med_manager',
    'group:compass:coach',
    'group:compass:care_navigator',
    'group:compass:care_support_coordinator',
    'group:compass:admin',
    'group:compass:clinical_manager',
    'group:compass:clinical_support',
    'group:compass:super_admin',
    'group:compass:billing_specialist',
];
var creds = {
    grant_type: 'password',
    client_id: process.env.CLIENT_ID,
    client_secret: process.env.CLIENT_SECRET,
    scope: scopes.join(' '),
};
var CFaUserAlt = chakra(FaUserAlt);
var CFaLock = chakra(FaLock);
/**
 *  A generic login form
 *
 * @returns {React.ReactNode}
 */
var Login = function () {
    var _a = useState(false), showPassword = _a[0], setShowPassword = _a[1];
    var _b = useLocalStorage('access_token', null, false), token = _b[0], setToken = _b[1];
    var _c = useState(''), errorMessage = _c[0], setErrorMessage = _c[1];
    var navigate = useNavigate();
    var _d = useForm(), control = _d.control, register = _d.register, getValues = _d.getValues, errors = _d.formState.errors;
    var logout = useLogout();
    var login = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var loginCredentials, headers, res, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    loginCredentials = __assign(__assign({}, creds), data);
                    headers = {
                        'Content-Type': 'application/json',
                        'Access-Control-Allow-Origin': '*',
                        'Access-Control-Allow-Methods': 'POST,PATCH,OPTIONS',
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, axios.post("".concat(DIGLET_URL, "/oauth/access_token"), loginCredentials, {
                            headers: headers,
                        })];
                case 2:
                    res = _a.sent();
                    if (res.status === 200) {
                        navigate('/notes/upcoming');
                    }
                    setToken(res.data.access_token);
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    setErrorMessage('Could not login successfully');
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var onSubmit = function (e) {
        if (e.cancelable) {
            e.preventDefault();
        }
        login(getValues());
    };
    /**
     * Update state with a new value provided by input field
     *
     * @returns {void}
     */
    var handleShowClick = function () { return setShowPassword(!showPassword); };
    /**
     * Render the component
     */
    return (_jsxs(Flex, __assign({ flexDirection: "column", width: "100wh", height: "100vh", backgroundColor: "gray.200", justifyContent: "center", alignItems: "center" }, { children: [_jsxs(Stack, __assign({ flexDir: "column", mb: 2, justifyContent: "center", alignItems: "center" }, { children: [_jsx(Avatar, { bg: "teal.500" }), _jsx(Heading, __assign({ color: "teal.400" }, { children: "Welcome" })), _jsxs(Box, __assign({ minW: { base: '90%', md: '468px' } }, { children: [_jsx(RHFDevTool, { control: control, placement: "top-left" }), _jsx("form", __assign({ onSubmit: onSubmit }, { children: _jsxs(Stack, __assign({ spacing: 4, p: "1rem", backgroundColor: "whiteAlpha.900", boxShadow: "md" }, { children: [_jsx(FormControl, { children: _jsxs(InputGroup, { children: [_jsx(InputLeftElement, { pointerEvents: "none", children: _jsx(CFaUserAlt, { color: "gray.300" }), pl: 4 }), _jsx(FormInput, { id: "username", type: "email", name: "username", placeholder: "email address", defaultValue: "", displayErrors: true, register: register, rules: {
                                                            required: 'You must enter your email address.',
                                                            pattern: emailPattern.value,
                                                        }, errors: errors, pl: 50 })] }) }), _jsxs(FormControl, { children: [_jsxs(InputGroup, { children: [_jsx(InputLeftElement, { pointerEvents: "none", color: "gray.300", children: _jsx(CFaLock, { color: "gray.300" }) }), _jsx(FormInput, { id: "password", name: "password", type: showPassword ? 'text' : 'password', placeholder: "Password", displayErrors: true, register: register, rules: {
                                                                required: 'You must enter your password.',
                                                                min: 3,
                                                                max: 30,
                                                            }, errors: errors, pl: 50 }), _jsx(InputRightElement, __assign({ width: "4.5rem" }, { children: _jsx(Button, __assign({ h: "1.75rem", size: "sm", onClick: handleShowClick }, { children: showPassword ? 'Hide' : 'Show' })) }))] }), _jsx(FormHelperText, __assign({ textAlign: "right" }, { children: _jsx(Link, { children: "forgot password?" }) }))] }), _jsx(Box, __assign({ display: "flex", justifyContent: "center" }, { children: _jsx(Text, __assign({ color: "red.500" }, { children: errorMessage })) })), _jsx(Button, __assign({ borderRadius: 0, id: "login-button", type: "submit", variant: "solid", colorScheme: "teal", width: "full", disabled: Object.keys(errors).length > 0 }, { children: "Login" })), _jsx(Button, __assign({ type: "reset", variant: "redLinks", colorScheme: "teal", width: "full", onClick: function () { return logout(); } }, { children: "Logout" }))] })) }))] }))] })), _jsxs(Box, { children: ["New to user?", ' ', _jsx(Link, __assign({ color: "teal.500", href: "#" }, { children: "Sign Up" }))] })] })));
};
export default Login;
